import{__require as r}from"./to-integer-or-infinity.js";var t,i;function n(){if(i)return t;i=1;var n=r(),e=Math.max,a=Math.min;return t=function(r,t){var i=n(r);return i<0?e(i+t,0):a(i,t)}}export{n as __require};
//# sourceMappingURL=to-absolute-index.js.map
